import {createBrowserHistory} from 'history';

/**
 * Shared browser history instance.
 * Used directly by App.js to subscribe to location changes
 * (bypassing Router's class-component state which React 18 can batch/defer).
 */
export const history = createBrowserHistory();
